const LK_RadioButtonCheck =({color,width,height})=>{
    return(
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81 81" fill={color} width={width} height={height}>
            {/*  
                <defs>
                    <style>
                    .cls-1 {
                        fill: #005c8b;
                    }

                    .cls-1, .cls-2 {
                        stroke-width: 0px;
                    }

                    .cls-2 {
                        fill: #fff;
                    }
                    </style>
                </defs>
            */}
            <g>
                <circle class="cls-2" cx="40.5" cy="40.5" r="40.5" fill="none"/>
                <path class="cls-1" d="M40.5,3c20.68,0,37.5,16.82,37.5,37.5s-16.82,37.5-37.5,37.5S3,61.18,3,40.5,19.82,3,40.5,3M40.5,0C18.13,0,0,18.13,0,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5S62.87,0,40.5,0h0Z"/>
            </g>
            <circle class="cls-1" cx="40.5" cy="40.5" r="30"/>        
        </svg>
    );
};

export default LK_RadioButtonCheck;